import { render, staticRenderFns } from "./chooseCouponShopPool.vue?vue&type=template&id=ed524986&scoped=true"
import script from "./chooseCouponShopPool.vue?vue&type=script&lang=js"
export * from "./chooseCouponShopPool.vue?vue&type=script&lang=js"
import style0 from "./chooseCouponShopPool.vue?vue&type=style&index=0&id=ed524986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed524986",
  null
  
)

export default component.exports